exports.APIS = {
  Home: {
    Success_Speaks: "/v1/website/get-website/get-success-speaks",
    HomeFaq: "/v1/website/get-website/get-all-faq",

    AboutUsOurStory: "/v1/website/get-website/get-aboutus-our-story",

    ContactUsGetInTouch: "/v1/website/get-website/get-in-touch",

    getAllUniversity: "/v1/website/get-website/get-all-university",

    getAllOurProcess: "/v1/website/get-website/get-all-our-process",

    getAllMeetOurTeam: "/v1/website/get-website/get-all-meet-our-team",

    getAllCountry: "/v1/website/get-website/get-all-country",
  },

  contactUs: {
    post_contact_us: "/v1/website/contact-us/contact-us-form",
  },

  Advice: {
    need_advice: "/v1/website/home/need-advice",
  },

  Internship: {
    all_data: "/v1/website/get-website/get-all-data-of-internship",
  },

  Blog: {
    blogs: "/v1/website/get-website/get-all-blogs",
  },
};
